import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from 'primeng/accordion';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { EllipsisTooltipComponent } from '../../../../../shared/components/general/ellipsis-tooltip/ellipsis-tooltip.component';
import { PickupLocation, ScheduleCourierPickupOrder } from '../../../_core/interfaces';
import { ScheduleCourierPickUpFormService } from '../core/schedule-courier-pick-up-form.manager';

@Component({
    selector: 'app-schedule-courier-pick-up-form',
    standalone: true,
    imports: [
        FieldsetModule,
        TranslateModule,
        ReactiveFormsModule,
        AccordionModule,
        DropdownModule,
        MultiSelectModule,
        InputTextModule,
        EllipsisTooltipComponent,
    ],
    templateUrl: './schedule-courier-pick-up-form.component.html',
    styleUrls: ['./schedule-courier-pick-up-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleCourierPickUpFormComponent {
    readonly ordersList = input.required<ScheduleCourierPickupOrder[]>();
    readonly locationsList = input.required<PickupLocation[]>();

    readonly scheduleCourierForm = this.formService.getScheduleCourierForm();

    constructor(private formService: ScheduleCourierPickUpFormService) {}

    calculateNumberOfTubes(): void {
        let numberOfTubes = this.orderNames.value?.reduce(
            (totalNumberOfTubes, currentOrder) => totalNumberOfTubes + currentOrder.numberOfTubes,
            0
        );

        this.numberOfTubes.setValue(numberOfTubes ?? 0);
    }

    get pickupLocation(): FormControl<PickupLocation> {
        return this.scheduleCourierForm.controls['pickupLocation'] as FormControl<PickupLocation>;
    }

    get organization(): FormControl<string> {
        return this.scheduleCourierForm.controls['organization'] as FormControl<string>;
    }

    get numberOfTubes(): FormControl<number> {
        return this.scheduleCourierForm.controls['numberOfTubes'] as FormControl<number>;
    }

    get orderNames(): FormControl<ScheduleCourierPickupOrder[]> {
        return this.scheduleCourierForm.controls['orderNames'] as FormControl<ScheduleCourierPickupOrder[]>;
    }
}
